import { axiosClient } from '@/shared/api/axiosClient';
import type { ApiSuccess } from '@/shared/api/apiResponse.types';
import type { SongRequest, SubmitRequestPayload } from '../model/request.types';

export const requestApi = {
  // ── Guest ─────────────────────────────────────────────────────────────────
  joinEvent: (eventCode: string) =>
    axiosClient.post(`/events/${eventCode}/join`),

  submitRequest: (eventCode: string, payload: SubmitRequestPayload) =>
    axiosClient
      .post<ApiSuccess<SongRequest>>(`/events/${eventCode}/song-requests`, payload)
      .then((r) => r.data.data),

  getMyRequests: (eventCode: string) =>
    axiosClient
      .get<ApiSuccess<SongRequest[]>>(`/events/${eventCode}/my-requests`)
      .then((r) => r.data.data),

  // ── DJ ────────────────────────────────────────────────────────────────────
  getDjRequests: (eventId: string, params?: { limit?: number; cursor?: string }) =>
    axiosClient
      .get<ApiSuccess<{ items: SongRequest[]; nextCursor?: string }>>(`/dj/events/${eventId}/song-requests`, { params })
      .then((r) => r.data.data),

  approveRequest: (requestId: string) =>
    axiosClient
      .post<ApiSuccess<SongRequest>>(`/dj/song-requests/${requestId}/approve`)
      .then((r) => r.data.data),

  rejectRequest: (requestId: string, reason?: string) =>
    axiosClient
      .post<ApiSuccess<SongRequest>>(`/dj/song-requests/${requestId}/reject`, { rejectionReason: reason ?? '' })
      .then((r) => r.data.data),

  // keep=true exempts the app-added track from after-play removal; keep=false restores the default (remove)
  keepRequest: (requestId: string, keep = true) =>
    axiosClient
      .post<ApiSuccess<SongRequest>>(`/dj/song-requests/${requestId}/keep`, { keep })
      .then((r) => r.data.data),

};
